import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { SharedService } from '../shared.service';
import { AuthService } from '../../../core/auth.service';
import { Router, RouterLink } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';
import { FirebaseService } from '../../services/firebase.service';
import { ToastService } from '@app/services/toast.service';
import { DealerService } from '../../services/dealer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DrawerModule } from 'primeng/drawer';
import { FaqService } from '../../services/faq.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-navbar',
    imports: [
      UpperCasePipe,
      DatePipe,
      FormsModule,
      DrawerModule,
      RouterLink
    ],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss',})

export class NavbarComponent implements OnInit {
  @Input() variant: 'dealer' | 'gdc' = 'dealer';

  username: string | null = '';
  position_name: string | null = '';
  userType: string | null = '';
  isMobileSearch: boolean = false;
  helpSidebar = false;
  helpSearch = '';
  helpDocuments: any[] = [];
  helpDocumentsLoading = false;
  helpDocumentsLoaded = false;
  helpDocumentsError = false;
  subuserType = this.encryptionService.getFromLocalStorage('position_type');
  constructor(private sharedService: SharedService,
    private authService: AuthService,
    private router: Router,
    private encryptionService: EncryptionService,
    private fs: FirebaseService,
    private toastr: ToastService,
    private dealerService: DealerService,
    private spinner: NgxSpinnerService,
    private faqService: FaqService,
  ) {
  }

  ngOnInit(): void {
    this.username = this.encryptionService.getFromLocalStorage('username');
    this.position_name = this.encryptionService.getFromLocalStorage('position_name');
    this.userType = this.encryptionService.getFromLocalStorage('user_type');
  }

  openHelpSidebar(): void {
    this.helpSidebar = true;
    if (this.helpDocumentsLoaded || this.helpDocumentsLoading) return;

    this.helpDocumentsLoading = true;
    this.helpDocumentsError = false;
    this.faqService.getHelpDocuments({}).subscribe({
      next: (response: any) => {
        this.helpDocuments = (response?.data ?? [])
          .filter((document: any) => document.is_active)
          .sort((first: any, second: any) =>
            (second.ordering ?? 0) - (first.ordering ?? 0));
        this.helpDocumentsLoaded = true;
        this.helpDocumentsLoading = false;
      },
      error: (error: unknown) => {
        console.error('Failed to load help documents:', error);
        this.helpDocumentsError = true;
        this.helpDocumentsLoading = false;
      },
    });
  }

  get filteredHelpDocuments(): any[] {
    const term = this.helpSearch.trim().toLowerCase();
    return this.helpDocuments.filter(doc => !term || `${doc.app_name} ${doc.document_name}`.toLowerCase().includes(term));
  }
  SerachMbInfo() {
    this.isMobileSearch = !this.isMobileSearch
  }
  ngDocheck() {
    this.detectMobileView(false);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
  }
  detectMobileView(val: boolean) {
    // alert("okay")
    this.sharedService.toggleClass(val);
    // this.isMobile=val;
    // this.isMobileView = window.innerWidth <= 768; // Example: mobile is defined as screen width <= 768px
  }
  logout() {
    const isGdc = this.variant === 'gdc';
    this.fs.addFirebaseNewEvent(isGdc ? 'Navbar TMCVL Logout' : 'Navbar Logout', {
      page_title: isGdc ? 'TMCVL Navbar' : 'Navbar',
      action: "Logout Button Clicked",
      res: '',
    });

    this.authService.logout();
  }

  userProfile() {
    const isGdc = this.variant === 'gdc';
    this.fs.addFirebaseNewEvent(isGdc ? 'Navbar TMCVL User Profile' : 'Navbar User Profile', {
      page_title: isGdc ? 'TMCVL Navbar' : 'Navbar',
      action: "User Profile Clicked",
      res: '',
    });
  }

  createVasorder(val: boolean): void {
    
    this.sharedService.toggleCreateorderClass(val);
    this.router.navigate(['/dealer/order/enquiry-order']);
  }

  navigateHome(): void {
    if (this.variant === 'dealer') {
      this.router.navigate(['/dealer/pipeline/A0']);
    } else if (this.userType === 'approver') {
      this.router.navigate(['/tml/price-deviation/pending']);
    } else {
      this.router.navigate(['/tml/pipeline/A0']);
    }
  }

  positionSidebar = false;
  selectedPosition: any = '';

  positions: any[] = [];
  filteredPositions: any[] = [];
  searchTerm = '';

  onPositionChange(pos: any) {
    this.selectedPosition = pos;
  }

  updatePosition() {
    // if (!this.selectedPosition) {
    //   this.toastr.warning('Please select a valid and new position');
    //   return;
    // }

    const payload = { position_name: this.selectedPosition.position };
    this.spinner.show('main');
    this.dealerService.updatePosition(payload).subscribe({
      next: (response: any) => {
        this.spinner.hide('main');
        this.encryptionService.setToLocalStorage('position_name', this.selectedPosition.position);
        this.encryptionService.setToLocalStorage('position_type', this.selectedPosition.position_type.toUpperCase());
        if (this.variant === 'dealer') {
          const dealerAc = response?.dealer_ac || {};
          this.encryptionService.setToLocalStorage('tml_payment_active', (dealerAc.tml_payment_active ?? false).toString());
          this.encryptionService.setToLocalStorage('amc_memi_active', (dealerAc.amc_memi_active ?? false).toString());
          this.encryptionService.setToLocalStorage('is_fms_active', (dealerAc.is_fms_active ?? false).toString());
          this.encryptionService.setToLocalStorage('is_ew_active', (dealerAc.is_ew_active ?? false).toString());
          this.encryptionService.setToLocalStorage('fms_memi_active', (dealerAc.fms_memi_active ?? false).toString());
          this.encryptionService.setToLocalStorage('fms_qemi_active', (dealerAc.fms_qemi_active ?? false).toString());
          this.encryptionService.setToLocalStorage('amc_qemi_active', (dealerAc.amc_qemi_active ?? false).toString());
        }
        this.toastr.success('Position updated successfully.');
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      },
      error: (err: any) => {
        this.spinner.hide('main');
        this.toastr.warning('Position update failed. Please check your selection or try again.');
      }
    });
  }

  getPositions(): void {
    this.spinner.show('main');

    this.dealerService.getPositions({}).subscribe({
      next: (response: { data: any[] }) => {
        this.spinner.hide('main');

        const positions = response?.data || [];

        if (positions.length === 0) {
          this.toastr.warning('No positions available.', 'Warning');
          return;
        }

        // Filter active positions if needed
        // const activePositions = positions.filter(pos => pos.is_active_position);

        this.positions = positions
          .sort((a, b) => Number(b.is_active_position) - Number(a.is_active_position))
          .map(pos => ({
            position_type: pos.position_type,
            position: pos.position_name,
            allowed_position: pos.is_allowed_position,
            primary: pos.is_primary_position,
            active: pos.is_active_position
          }));
        if (this.variant === 'gdc') {
          this.filteredPositions = [...this.positions];
        } else {
          this.selectedPosition = this.positions.find((position: any) => position.active === true);
          if (this.selectedPosition) {
            const oldPosition = this.encryptionService.getFromLocalStorage('position_name');
            this.position_name = this.selectedPosition.position;
            this.encryptionService.setToLocalStorage('position_name', this.selectedPosition.position);
            this.encryptionService.setToLocalStorage('position_type', this.selectedPosition.position_type.toUpperCase());
            if (oldPosition && oldPosition !== this.position_name) {
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
              this.toastr.success('Position updated from other login.');
            }
          }
        }
        this.positionSidebar = true;
      },
      error: (err) => {
        this.positionSidebar = false;
        this.spinner.hide('main');
        this.toastr.error('Failed to load positions. Please try again later.', 'Error');
        console.error('Position list fetch failed', err);
      }
    });
  }

  filterPositions(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredPositions = this.positions.filter((position: any) =>
      position.position.toLowerCase().includes(term) ||
      position.position_type.toLowerCase().includes(term)
    );
  }

  get visiblePositions(): any[] {
    return this.variant === 'gdc' ? this.filteredPositions : this.positions;
  }
}
